export default Object.freeze({
  VETERAN_GOLD_CARD: 'veteran gold card',
  VETERAN_GOLD_CARD_PROPER: 'Veteran Gold Card',
  VETERAN_GOLD_CODE: 'GOLD',
  VETERAN_WHITE_CARD: 'veteran white card',
  VETERAN_WHITE_CARD_PROPER: 'Veteran White Card',
  VETERAN_WHITE_CODE: 'WHITE',
});
